module.exports = __webpack_public_path__ + "img/two.e6afb639.png";